import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const projectService = {
  /** 查询项目设施资产台账。 */
  assets: (id, params) => axios.get(`${iffApi}/jxxf/wb/project/${id}/assets`, { params }),
  /** 单条新增项目设施资产。 */
  createAsset: (id, data) => axios.post(`${iffApi}/jxxf/wb/project/${id}/assets`, data),
  /** 软删除项目设施资产。 */
  deleteAsset: (id, assetId) => axios.delete(`${iffApi}/jxxf/wb/project/${id}/assets/${assetId}`),
  /** 下载项目专属的设施资产导入模板。 */
  downloadAssetTemplate: id => axios.get(`${iffApi}/jxxf/wb/project/${id}/assets/template`, { responseType: 'blob' }),
  /** 导入项目设施资产。 */
  importAssets: (id, data) => axios.post(`${iffApi}/jxxf/wb/project/${id}/assets/import`, data),
  /** 修改江西维保项目。 */
  update: (id, data) => axios.put(`${iffApi}/jxxf/wb/project/${id}`, data),
  /** 删除江西维保项目。 */
  delete: id => axios.delete(`${iffApi}/jxxf/wb/project/${id}`),
  /** 查询江西维保项目详情。 */
  detail: id => axios.get(`${iffApi}/jxxf/wb/project/${id}`),
  /** 分页查询江西维保项目。 */ page: params => axios.get(`${iffApi}/jxxf/wb/project`, { params }),
  /** 查询标准设施系统。 */ facilities: () => axios.get(`${iffApi}/jxxf/wb/project/facilities`),
  /** 创建江西维保项目。 */ create: data => axios.post(`${iffApi}/jxxf/wb/project`, data)
};
